module.exports = __webpack_public_path__ + "static/img/customers_22.af9c6f8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/images/customers_22.png
// module id = MV8o
// module chunks = 1